export default "__VITE_ASSET__D0y39_RU__"